import React, { useState, useEffect, useCallback } from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../Assets/Animation';

export default function ImageSlider() {
  const [images, setImages] = useState([]);
  const navigate = useNavigate();

  const fetchCraousel = useCallback(async () => {
    try {
      const response = await fetch(`/api/getCarousel`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ activeInactive: 1 }),
      });

      if (response.ok) {
        const Data = await response.json();
        setImages(Data);
      }
    } catch (error) {
      console.error("Carousel fetch error:", error);
    }
  }, []);

  useEffect(() => { fetchCraousel(); }, [fetchCraousel]);

  return (
    <div className="bg-[#0A1F44]">
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">

          <div className="carousel-item active">
            <Container maxWidth="xl">
              <div className="row align-items-center py-5">

                <div className="col-lg-7 text-white space-y-4">
                  <h1 className="fw-bold leading-tight" style={{ fontSize: 'clamp(28px, 4vw, 44px)' }}>
                    Shaping Bright Futures Through Quality Education
                  </h1>

                  <p className="opacity-75" style={{ fontSize: 'clamp(15px, 2vw, 18px)' }}>
                    At <strong>Fatehpur Public School</strong>, we cultivate knowledge, character,
                    and confidence in a safe and inspiring learning environment.
                  </p>

                  <p className="opacity-75" style={{ fontSize: 'clamp(15px, 2vw, 18px)' }}>
                    Our focus on academic excellence, values, and holistic development prepares
                    students to thrive in an ever-evolving world.
                  </p>

                  <div className="pt-3">
                    <Button
                      variant="contained"
                      endIcon={<ArrowForward />}
                      sx={{
                        background: "linear-gradient(90deg, #2563eb, #059669)",
                        padding: "12px 28px",
                        fontSize: "16px",
                        fontWeight: 600,
                        borderRadius: "8px",
                        textTransform: "none",
                      }}
                      onClick={() => navigate(`/AdmissionForm?Type=AdmissionForm`)}
                    >
                      Start Application
                    </Button>
                  </div>
                </div>

                <div className="col-lg-5 d-flex justify-content-center mt-4 mt-lg-0">
                  <Lottie animationData={animationData} loop autoplay style={{ width: '100%', maxWidth: '420px' }}/>
                </div>

              </div>
            </Container>
          </div>

          {images.map((image, index) => (
            <div key={index} className="carousel-item">
              <img src={`/Carousel/${image.CarouselURL}?timestamp=${new Date().getTime()}`} className="d-block w-100" style={{ objectFit: "cover", maxHeight: "600px" }} alt={image.CarouselTitle} />
            </div>
          ))}

        </div>

        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span className="carousel-control-next-icon"></span>
        </button>

      </div>
    </div>
  );
}
